import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { FC } from "react";
import { SketchPicker } from "react-color";

interface Props {
  color: string;
  onChange: (color: string) => void;
}

export const ColorPicker: FC<Props> = ({ color, onChange }) => {
  return (
    <Popover>
      <PopoverTrigger>
        <div
          className="rounded-md w-[25px] h-[25px] border"
          style={{
            backgroundColor: color,
          }}
        >
          &nbsp;
        </div>
      </PopoverTrigger>
      <PopoverContent className="p-4 w-full" side="bottom">
        <SketchPicker color={color} onChangeComplete={({ hex }) => onChange(hex)} disableAlpha={true} />
      </PopoverContent>
    </Popover>
  );
};
